export default __webpack_public_path__ + "static/media/it-help.a6ad39b8.jpg";